export const getRelativeUrl = (url: string): string => {
  if (!url || url.trim() === "") return "";

  try {
    const parsedUrl = new URL(url);
    return parsedUrl.pathname + parsedUrl.search;
  } catch (error) {
    console.error(`Invalid URL: '${url}'`, error);
    return url;
  }
};

export const buildUrl = (cnBaseUrl: string, path: string): string => {
  return new URL(path, cnBaseUrl).toString();
};
